import { calculationInitialState } from './calculation.state';
import {
  addAnnex,
  emptyCart,
  loadCalculation,
  removeAnnex,
  reset,
  setAccessories,
  setActiveTab,
  setCalculateAccessories,
  setCalculation,
  setCalculationPartialPayment,
  setCart,
  setContact,
  setCustomTiles,
  setGdpr,
  setIsCompany,
  setMeasurements,
  setModels,
  setOffer,
  setPartialPayment,
  setRainSystem,
  setStepperStep,
  updateAnnex,
  updateRainSystem,
} from './calculation.actions';
import { createReducer, on } from '@ngrx/store';
import { CalculationTypeEnum } from '../../api/models/calculation-type-enum';
import { cloneDeep } from 'lodash-es';

export const calculationReducer = createReducer(
  calculationInitialState,
  on(setIsCompany, (state, { isCompany }) => ({ ...state, isCompany })),
  on(setStepperStep, (state, { stepperStep }) => ({ ...state, stepperStep })),
  on(setGdpr, (state, { isGdprAccepted }) => ({ ...state, isGdprAccepted })),
  on(setActiveTab, (state, { roofType }) => ({ ...state, activeTab: roofType })),
  on(loadCalculation, (state, { payload, roofType }) => ({ ...state, [roofType]: payload, activeTab: roofType })),
  on(setAccessories, (state, { accessories }) => ({
    ...state,
    calculateAccessories: false,
    [state.activeTab]: { ...state[state.activeTab], accessories: cloneDeep(accessories), isLoaded: false },
  })),
  // on(setContact, (state, { contact }) => ({
  //   ...state,
  //   contact,
  // })),
  on(setContact, (state, { contact }) => {
    return {
      ...state,
      contact,
    };
  }),
  on(setModels, (state, { models, isLoaded = false }) => ({
    ...state,
    models,
    isLoaded,
  })),
  on(setRainSystem, (state, { rainSystem }) => ({
    ...state,
    [state.activeTab]: {
      ...state[state.activeTab],
      rainSystem: cloneDeep(rainSystem),
      isLoaded: false,
    },
  })),
  on(updateRainSystem, (state, rainSystemMeasurements) => ({
    ...state,
    [state.activeTab]: {
      ...state[state.activeTab],
      isLoaded: false,
      rainSystem: {
        ...state[state.activeTab].rainSystem,
        rainSystem: !!state[state.activeTab].rainSystem?.rainSystem,
        ...rainSystemMeasurements,
        type: undefined,
      },
    },
  })),
  on(setMeasurements, (state, { measurements }) => ({
    ...state,
    [state.activeTab]: { ...state[state.activeTab], measurements: cloneDeep(measurements), isLoaded: false },
  })),
  on(addAnnex, (state, { annex }) => ({
    ...state,
    [state.activeTab]: {
      ...state[state.activeTab],
      annexes: [...state[state.activeTab].annexes, annex],
      isLoaded: false,
    },
  })),
  on(updateAnnex, (state, { annex, index }) => {
    const annexes = cloneDeep(state[state.activeTab].annexes);
    annexes[index] = annex;
    return {
      ...state,
      [state.activeTab]: {
        ...state[state.activeTab],
        annexes,
        isLoaded: false,
      },
    };
  }),
  on(removeAnnex, (state, { index }) => {
    const annexes = cloneDeep(state[state.activeTab].annexes);
    annexes.splice(index, 1);
    return {
      ...state,
      [state.activeTab]: {
        ...state[state.activeTab],
        annexes,
        isLoaded: false,
      },
    };
  }),
  on(setCustomTiles, (state, { tiles }) => {
    return {
      ...state,
      [CalculationTypeEnum.Custom]: { ...state[CalculationTypeEnum.Custom], measurements: { tilesByHeight: tiles } },
    };
  }),
  on(setCalculation, (state, { calculation }) => ({
    ...state,
    [state.activeTab]: { ...state[state.activeTab], apiCalculation: calculation },
  })),
  on(setCalculationPartialPayment, (state, { partialPayment }) => ({
    ...state,
    [state.activeTab]: { ...state[state.activeTab], partialPayment },
  })),
  on(setOffer, (state, { offer }) => ({
    ...state,
    [state.activeTab]: { ...state[state.activeTab], offer },
  })),
  on(setCalculateAccessories, (state, { calculateAccessories }) => ({
    ...state,
    [state.activeTab]: { ...state[state.activeTab], calculateAccessories, isLoaded: false },
  })),
  on(setPartialPayment, (state, { partialPayment }) => ({
    ...state,
    partialPayment,
  })),
  on(setCart, (state, { cart }) => ({
    ...state,
    cart,
  })),
  on(emptyCart, (state) => ({
    ...state,
    cart: undefined,
  })),
  on(reset, () => calculationInitialState),
);
